"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const filterPostsByCategory_1 = require("@/util/filterPostsByCategory");
function PostHeader(posts, selectedCategory) {
    const filteredPosts = (0, filterPostsByCategory_1.filterPostsByCategory)(posts, selectedCategory);
    return `
  <div class="px-4 mb-4 text-title font-GmarketSansMedium">
    Posts <span class="text-body font-GmarketSansLight text-muted">${filteredPosts.length}</span>
  </div>
  `;
}
exports.default = PostHeader;
